var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('participation-view-content-container',{attrs:{"current-stage":_vm.currentStage,"grey-background":_vm.isCommunityProject}},[(_vm.isCommunityProject)?_c('community-project-detail'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }